<template>
    <div
        v-if="props.text"
        :class="props.type">

        <template v-if="icons[props.type]">
            <Icon :icon="icons[props.type]" />
            <!-- <span class="devider"></span> -->
        </template>
        <span>{{ props.text }}</span>
    </div>
</template>

<script setup>
const props = defineProps({
    type: { type: String, default: 'info' },
    text: { type: [String, null], default: null }
});

const icons = {
    'info': 'exclamation',
    'success': 'exclamation',
    'attention': 'exclamation'
}
</script>

<style lang="scss" scoped>
div {
    @include message;
    // backdrop-filter: blur(6px);
}
</style>
